import React from 'react';
import { NavLink } from 'react-router-dom';

// Don't refactor to functional component as it breaks documentation generation
export default class PortalNavLink extends React.Component {
  render() {
    return <NavLink className={'portal-nav-link'} {...this.props} />;
  }
}
